<template>
    <el-dialog :visible.sync="visible"
        :title="$t('privateNetInstance.bindTitle')"
        :close-on-click-modal="false"
        :before-close="handleClose" class="bind-dialog">
        <el-alert :title="$t('privateNetInstance.chooseBindTip', [instanceName])"
            type="info"
            :closable="false">
        </el-alert>
        <el-form ref="form" label-width="150px">
            <!--目标网络接口名称-->
            <el-form-item :label="$t('eip.text.targetInternetAccessName') | withColon" >
                <el-radio-group v-model="selectTargetInternetAccessName" @change="changeTargetInternetAccessName">
                    <el-radio-button v-for="item in targetInternetAccessNames" :key="item.label" :label="item.label">
                        {{item.value}}
                    </el-radio-button>
                </el-radio-group>
            </el-form-item>
            <!--目标内网IP-->
            <el-form-item :label="$t('listPage.tableLabel.targetInternetIp') | withColon" required>
                <el-select v-model="form.selectedIpAddress" 
                    style="width: 50%;"
                    filterable      
                    popper-class="ip-address-select"
                    :no-data-text="$t('subnet.text.noAvailableIpAddress')"
                    :placeholder="$t('eip.help.targetIpAddressSearch')"
                    @visible-change="value=>getAvailablePrivateIps(value)">
                    <el-option v-for="item in ipAddressOptions" 
                        :key="item.value"
                        :label="item.label" 
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <!--选择EIP-->
            <el-form-item :label="$t('listPage.tableLabel.chooseEip') | withColon" required>
                <el-table :data="flexPublicNetList"
                    style="width: 100%;"
                    max-height="242"
                    class="bind-flex-net">
                    <el-table-column label="" min-width="20">
                        <template slot-scope="scope">
                            <el-radio v-model="radioVal"
                                :label="scope.$index">
                                {{ '' }}
                            </el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="elasticIp"
                        :label="$t('privateNetInstance.tableTitle.ip')">
                        <template slot-scope="scope">
                          <span>{{ scope.row.elasticIp }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="bandwidth"
                        :label="$t('privateNetInstance.tableTitle.bandWidth')">
                        <template slot-scope="scope">
                          <span>{{ scope.row.bandwidth.toString() | withColon('Mbps') }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="region"
                        :label="$t('privateNetInstance.tableTitle.region')">
                        <template slot-scope="scope">
                          <span>{{ transformRegion(scope.row.region) }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button @click="cancelBind">
                {{ $t('privateNetInstance.cancel') }}
            </el-button>
            <el-button @click="sureBind"
                type="primary"
                :disabled="radioVal === '' || !form.selectedIpAddress"
                :loading="sureLoading">
                {{ $t('privateNetInstance.bindSure') }}
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
import {
    TargetIpAddressChannelConstant
} from '@/common/Constants';
export default {
    name: 'BindFlexNet',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        instanceName: {
            type: String,
            default: ''
        },
        region: {
            type: String,
            default: ''
        },
        instanceId: {
            type: String,
            default: ''
        },
        loadBalancerId: {
            type: String,
            default: ''
        },
        // 负载均衡实例绑定IP的时候没有这个提示
        isSLB: {
            type: Boolean,
            default: false
        },
        // SLB负载均衡实例和另外两种实例绑定EIP调用接口不同
        isSlb: {
            type: Boolean,
            default: false
        },
        rowInfo: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            form: {
                selectedIpAddress: ''
            },
            flexPublicNetList: [],
            radioVal: '',
            bindIP: {},
            selectTargetInternetAccessName: 'primary',
            subnetId: this.rowInfo.subnetId, // 主网口或辅网口子网id
            ipAddressOptions: [],
            total: 0,
            sureLoading: false,
        };
    },
    computed: {
        //目标网络接口名称
        targetInternetAccessNames() {
            let interfaceMode = this.rowInfo.interfaceMode;
            if (interfaceMode === 'bond') {
                return [
                    {
                        label: 'primary',
                        value: this.$t('eip.text.singleInternetAccessChiefName')
                    }
                ];
            } else if (interfaceMode === 'dual') {
                return [
                    {
                        label: 'primary',
                        value: this.$t('eip.text.chiefInternetAccessName')
                    },
                    {
                        label: 'sub',
                        value: this.$t('eip.text.subInternetAccessName')
                    }
                ];
            }
        },
        TargetIpAddressChannelConstant: () => TargetIpAddressChannelConstant
    },
    watch: {
        radioVal(newVal, oldVal) {
            if (newVal !== '') {
                this.bindIP = this.flexPublicNetList[newVal];
            }
        }
    },
    created() {
        this.getAvailablePrivateIps(true)
        this.getFlexPublicNetList();
    },
    methods: {
        // 切换目标网络接口名称
        changeTargetInternetAccessName(label) {
            this.subnetId = label === 'primary' ? this.rowInfo.subnetId : this.rowInfo.extensionSubnetId
            this.form.selectedIpAddress = '';
        },
        transformRegion(region) {
            switch (region) {
                default:
                    return this.$t('eip.text.allAz');
            }
        },
        handleClose() {
          this.radioVal = '';
          this.bindIP = {};
          this.sureLoading = false;
          this.$emit('update:visible', false);
        },
        cancelBind() {
            this.handleClose();
        },
        sureBind() {
            this.sureLoading = true;
            const params = {
                region: this.region,
                elasticIpId: this.bindIP.elasticIpId,
                instanceId: this.instanceId,
                subnetId: this.subnetId,
                targetIp: this.form.selectedIpAddress
            };
            Ajax.put('/api/cps/associateElasticIp', params)
            .then((res) => {
              // this.$message.success(this.$t('privateNetInstance.operateSuccess'));
            })
            .catch(async (err) => {
                const { response } = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
                this.handleClose();
                this.$emit('refresh');
            });
        },
        getFlexPublicNetList() {
            const params = {
                region: this.region,
                status: 'disassociate',
                pageSize: 1000
            };
            Ajax.get('/api/cps/listElasticIps', params)
            .then((res) => {
                this.flexPublicNetList = res.data.elasticIps.filter(item => item.charge.chargeStatus === 'normal');
            })
            .catch(async (err) => {
                const {response} = err.data;
                try {
                    const json = await response.json();
                    target.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally();
        },
        // 获取当前实例的可用的私有IP列表
        getAvailablePrivateIps(isVisible) {
            if(!isVisible) {
                return
            }
            let params = {
                region: this.region,
                instanceId: this.instanceId,
                subnetId: this.subnetId,
                channel: TargetIpAddressChannelConstant.EIP
            }
            Ajax.get('/api/cps/availablePrivateIps', params)
            .then((res) => {
                this.ipAddressOptions = res.data.availablePrivateIps.map(item => {
                    return {
                        label: item,
                        value: item
                    }
                })
            })
            .catch(err=>{
                console.log(err)
            })
            .finally();
        },
    },
};
</script>

<style lang="scss">
  .bind-dialog {
    .el-alert {
        padding: 5px 8px;
        margin: 0 0 20px;
      .el-alert__title {
        word-break: break-all !important;
      }
    }

    
    .el-alert--info {
        background-color: #fff4e5;
        border-color: #ff9600;
        color: #ff9600;
    }

    .bind-flex-net {
      .el-radio {
        .el-radio__label {
          padding-left: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/BindEip.vue